import { all, fork } from 'redux-saga/effects';
import {
  LoginSaga, changePasswordSaga, getForgotPasswordSaga, getLinkedAccountSaga, getLoginInfoSaga,
} from './auth.Saga';
import { getClientClinicSaga, getClientDocSaga, getClientQuestionnairesSaga, getClientSignSaga, getParentInfoSaga, updateCLientSignsSaga, updateSignPinSaga } from './home.Saga';
import { getDocumentUrlSaga, getPendingDocSaga, getSignedDocSaga } from './doc.Saga';
import { getDiagnosisSaga } from './diagnosis.Saga';
import { ApplyClientSignatureSaga, getClientTreatmentPlanSignSaga, getTreatmentPlanReSignNotificationSaga, getTreatmentPlanSaga } from './treatment-plan.Saga';
import { getAppointmentSaga } from './appointment.Saga';
import { getMessageListSaga, getUnreadMessageCountSaga, markMessagesReadSaga } from './messages.Saga';



export function* rootSaga() {
  yield all([
    fork(LoginSaga),
    fork(getClientSignSaga),
    fork(getClientClinicSaga),
    fork(getClientDocSaga),
    fork(updateCLientSignsSaga),
    fork(updateSignPinSaga),
    fork(getLoginInfoSaga),
    fork(getSignedDocSaga),
    fork(getPendingDocSaga),
    fork(getDocumentUrlSaga),
    fork(getForgotPasswordSaga),
    fork(changePasswordSaga),
    fork(getDiagnosisSaga),
    fork(getTreatmentPlanSaga),
    fork(getAppointmentSaga),
    fork(getClientTreatmentPlanSignSaga),
    fork(ApplyClientSignatureSaga),
    fork(getMessageListSaga),
    fork(getUnreadMessageCountSaga),
    fork(markMessagesReadSaga),
    fork(getLinkedAccountSaga),
    fork(getParentInfoSaga),
    fork(getClientQuestionnairesSaga),
    fork(getTreatmentPlanReSignNotificationSaga)
  ]);
}
